import { HardDrive, Minimize2 } from "lucide-react";
import type React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export type UploadPreference = "original-only" | "compressed-only";

interface UploadPreferencesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (preference: UploadPreference) => void;
  fileCount: number;
}

export const UploadPreferencesDialog: React.FC<UploadPreferencesDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  fileCount,
}) => {
  const handleSelectPreference = (preference: UploadPreference) => {
    onConfirm(preference);
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent className="bg-gray-800 border-gray-700 text-white max-w-4xl">
        <DialogHeader>
          <DialogTitle className="text-white">
            Choose Upload Format
          </DialogTitle>
          <DialogDescription className="text-gray-400 text-center">
            Select how you want to upload {fileCount} {fileCount === 1 ? "panorama" : "panoramas"}.
          </DialogDescription>
        </DialogHeader>

        <div className="flex gap-4 w-full box-border py-4">
          <Button
            onClick={() => handleSelectPreference("original-only")}
            className="flex-[1_1_0%] h-auto p-8 flex flex-col items-center justify-center gap-4 bg-gray-700 hover:bg-gray-600 border-2 border-gray-600 hover:border-blue-500 text-white transition-all min-w-0 overflow-hidden box-border rounded-lg"
          >
            <div className="flex flex-col items-center gap-3">
              <div className="p-4 bg-blue-500/20 rounded-full">
                <HardDrive className="w-12 h-12 text-blue-400" />
              </div>
              <span className="font-semibold text-lg">Just upload</span>
            </div>
          </Button>

          <Button
            onClick={() => handleSelectPreference("compressed-only")}
            className="flex-[1_1_0%] h-auto p-8 flex flex-col items-center justify-center gap-4 bg-gray-700 hover:bg-gray-600 border-2 border-gray-600 hover:border-blue-500 text-white transition-all min-w-0 overflow-hidden box-border rounded-lg"
          >
            <div className="flex flex-col items-center gap-3">
              <div className="p-4 bg-blue-500/20 rounded-full">
                <Minimize2 className="w-12 h-12 text-blue-400" />
              </div>
              <span className="font-semibold text-lg">Compress before upload</span>
            </div>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
